export enum Command {
	SubscribeToNotificationHub = "SubscribeToNotificationHub",
	UnSubscribeToNotificationHub = "UnSubscribeToNotificationHub",
	NotifySignedInAnotherView = "NotifySignedInAnotherView",
}

export enum ServerEvent {
	Heartbeat = "Heartbeat",
	SignedOtherBrowser = "SignedOtherBrowser",
	SocketConnected = "mySocketConnected",
	UserMembershipChanged = "UserMembershipChanged",
	UserMembershipRemoved = "UserMembershipRemoved",
	UserPresenceChanged = "UserPresenceChanged",
	QueueChanged = "QueueChanged",
	CallSessionStateChanged = "callSessionStateChanged",
	WaitingCallChanged = "WaitingCallChanged",
	ActiveCallChanged = "ActiveCallChanged",
	SupervisedActiveInteractionChanged = "SupervisedActiveInteractionChanged",
	OnHoldStatusChanged = "OnHoldStatusChanged",
	WrapUpStarted = "WrapUpStarted",
	WrapUpStopped = "WrapUpStopped",
	DynamicUrlsChanged = "DynamicUrlsChanged",
	UserPermisionChanged = "UserPermisionChanged",
	SupervisorAgentsUpdated = "SupervisorAgentsUpdated",
	InternalPresenceChanged = "InternalPresenceChanged",
	VoicemailChanged = "VoicemailChanged",
	WaitingVoicemailChanged = "WaitingVoicemailChanged",
	VoicemailPickedUp = "VoicemailPickedUp",
	VoicemailTranscriptionFinished = "VoicemailTranscriptionFinished",
	TranscriptionMessage = "TranscriptionMessage",

	WaitingMessagingChanged = "WaitingMessagingChanged",
	ActiveMessagingChanged = "ActiveMessagingChanged",

	MessagingOffered = "MessagingOffered",
	MessagingAccepted = "MessagingAccepted",
	MessagingSessionRemoved = "MessagingSessionRemoved",

	NewMessageArrivedInConversation = "NewMessageArrivedInConversation",

	TextSummaryReady = "TextSummaryReady",

	QueueEstimatedWaitTimesUpdated = "QueueEstimatedWaitTimesUpdated",
	PlayBusyTone = "PlayBusyTone",
	UserTeamsClientChanged = "UserTeamsClientChanged",
	InteractionHistoryCustomerUpdated = "InteractionHistoryCustomerUpdated",

	SupervisedAgentWorkloadChanged = "SupervisedAgentWorkloadChanged",
	AgentWorkloadChanged = "AgentWorkloadChanged",
	SupervisedEmailConversationChanged = "SupervisedEmailConversationChanged",
	AgentAnsweredAfterOfferingTimeout = "AgentAnsweredAfterOfferingTimeout",
	SupervisedAgentRefreshed = "SupervisedAgentRefreshed",
	MyQueueContactsChanged = "MyQueueContactsChanged",

	WhatsAppMessageStatusUpdated = "WhatsAppMessageStatusUpdated",
	WebchatCustomerClosed = "WebchatCustomerClosed",
	WebchatVideoCallRequestChanged = "WebchatVideoCallRequestChanged",
	MessagingInteractionClosedByInactivity = "MessagingInteractionClosedByInactivity",

	SupervisedAgentSignedOut = "SupervisedAgentSignedOut",
	CancelSupervisorInvite = "CancelSupervisorInvite",
	AicLockStateChanged = "AicLockStateChanged",
	CallSentimentChanged = "CallSentimentChanged",
	CalleeDeclinedInvite = "CalleeDeclinedInvite",
	SettingsReloaded = "SettingsReloaded"
}

export enum RoomPrefix {
	Default = "v2",
	TenantId = "v2.t",
}
